module.exports = __webpack_public_path__ + "static/media/stopwatch.d7b61da7.svg";